import { ServiceTypeLabel, WalkerOfferedServicesResponse, WalkerProfileService } from '../../../../../types/api';
import { capitalizeFirstLetter } from '../../../../OvernightServicePreferencesContainer/helpers';
import { formatPrice } from '../../WalkerServices/helpers/formatPrice';
import { allServices, BasicServiceTypes } from '../assets';

export type WalkerRates = {
  services: typeof allServices[number][];
  servicesDetailed: typeof allServices[number][];
  description: string;
}

type Props = {
  servicesOffered: WalkerOfferedServicesResponse;
}

export const transformServicesOffered = ({
  servicesOffered,
}: Props) => {
  const reducedServices = allServices.reduce((acc, service) => {
    servicesOffered.items.forEach((offeredService) => {
      if (offeredService.serviceCategory === service.name) {
        const serviceCategoryLabel = (offeredService.serviceCategory as unknown) === 'drop-in'
          ? 'Drop-In'
          : capitalizeFirstLetter(offeredService.serviceCategory);
        acc.push({
          isChecked: true,
          label: serviceCategoryLabel,
          slug: service.name,
          imageUrl: service.icon,
        });
      }
    });
    return acc;
  }, [] as WalkerProfileService[]);

  const reducedRates: WalkerRates = {
    description: '*per night',
    services: [],
    servicesDetailed: [],
  };
  servicesOffered.items.forEach((serviceItem) => {
    const serviceCategoryLabel = (serviceItem.serviceCategory as unknown) === 'drop-in'
      ? 'Drop-In'
      : capitalizeFirstLetter(serviceItem.serviceCategory);

    reducedRates.services.push({
      label: serviceCategoryLabel as ServiceTypeLabel,
      serviceType: serviceItem.serviceCategory.replace('-', '_'),
      price: formatPrice(serviceItem.price.min),
      allowedCustomService: null,
      icon: allServices.find(
        (allServiceItem) => allServiceItem.name === serviceItem.serviceCategory)?.icon,
      name: serviceItem.serviceCategory,
      value: serviceItem.serviceCategory as BasicServiceTypes,
    });

    serviceItem.serviceTypes.forEach((serviceType) => {
      reducedRates.servicesDetailed.push({
        label: serviceCategoryLabel as ServiceTypeLabel,
        price: formatPrice(serviceType.price.amount),
        allowedCustomService: null,
        icon: allServices.find(
          (allServiceItem) => allServiceItem.name === serviceItem.serviceCategory)?.icon,
        name: serviceItem.serviceCategory,
        serviceType: serviceType.serviceType,
        value: serviceType.serviceType as BasicServiceTypes,
      });
    });
  });

  return {
    reducedServices,
    reducedRates,
  };
};
